import { lockedContentChanged } from 'features/layout/features/content/contentSlice';
import { selectedScreenshareClosed } from 'features/screenshare/screenshareSlice';
import { call, put, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { RTCClient } from 'utils/webrtc';
import { selectRoomStatus } from 'features/room/roomSlice';
import { RoomStatus } from 'features/room/types';
import { SFrameManager } from 'features/e2ee/SFrameManager';
import { E2EEManager } from 'features/e2ee/E2EEManager';
import { selectE2eeEnabled } from 'features/e2ee/e2eeSlice';
import { board } from 'utils/whiteboard/BoardStateManager';
import {
  activeFilesCollectionCleared,
  activeWhiteboardsCollectionCleared,
  openedFileCleared,
} from 'features/content-library/contentLibrarySlice';

export function* prepareReconnectionSaga() {
  const roomStatus: RoomStatus = yield select(selectRoomStatus);
  if (roomStatus !== 'joined') {
    return;
  }

  SignalingSocket.isRoomJoined = false;

  yield call(RTCClient.destroy);

  yield put(selectedScreenshareClosed());
  yield put(lockedContentChanged(null));

  yield put(openedFileCleared());
  yield put(activeFilesCollectionCleared());
  yield put(activeWhiteboardsCollectionCleared());

  const e2eeEnabled: boolean = yield select(selectE2eeEnabled);
  if (e2eeEnabled) {
    yield call(SFrameManager.cleanup);
    yield call(E2EEManager.cleanup);
  }

  board.whiteboardId = null;
}
